<template>
  <b-container fluid class="p-5">
    <b-row class="my-5 d-flex justify-content-center">
      <b-col sm="8" align-v="center">
        <div style="line-height: 2; direction: ltr; text-align: left;">
          <p>Privacy Policy</p>
          <p><br></p>
          <p>Introduction</p>
          <p>Our privacy policy will help you understand what information we collect at Iraq Private
            Banks League, how Iraq Private Banks League uses it, and what choices you have. Iraq Private Banks League
            built the Masrafna app as a free app. This SERVICE is provided by Iraq Private Banks League at no cost and
            is
            intended for use as is. If you choose to use our Service, then you agree to the collection and use of
            information in relation with this policy. The Personal Information that we collect are used for providing
            and
            improving the Service. We will not use or share your information with anyone except as described in this
            Privacy Policy. The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions,
            which is accessible in our website, unless otherwise defined in this Privacy Policy.</p>
          <p><br></p>
          <p>Information Collection and Use</p>
          <p>For a better experience while using our Service, we may require you to provide us with
            certain personally identifiable information, including but not limited to users name, email address, gender,
            location, pictures. The information that we request will be retained by us and used as described in this
            privacy policy. The app does use third party services that may collect information used to identify you.</p>
          <p><br></p>
          <p>Cookies</p>
          <p>Cookies are files with small amount of data that is commonly used an anonymous unique
            identifier. These are sent to your browser from the website that you visit and are stored on your devices’s
            internal memory.</p>
          <p>This Services does not uses these “cookies” explicitly. However, the app may use third
            party code and libraries that use “cookies” to collection information and to improve their services. You
            have
            the option to either accept or refuse these cookies, and know when a cookie is being sent to your device. If
            you choose to refuse our cookies, you may not be able to use some portions of this Service.</p>
          <p><br></p>
          <p>Location Information</p>
          <p>Some of the services may use location information transmitted from users' mobile
            phones. We only use this information within the scope necessary for the designated service.</p>
          <p><br></p>
          <p>Device Information</p>
          <p>We collect information from your device in some cases. The information will be utilized
            for the provision of better service and to prevent fraudulent acts. Additionally, such information will not
            include that which will identify the individual user.</p>
          <p><br></p>
          <p>Service Providers</p>
          <p>We may employ third-party companies and individuals due to the following reasons:</p>
          <p>&nbsp;• To facilitate our Service;</p>
          <p>&nbsp;• To provide the Service on our behalf;</p>
          <p>&nbsp;• To perform Service-related services; or</p>
          <p>&nbsp;• To assist us in analyzing how our Service is used.</p>
          <p>We want to inform users of this Service that these third parties have access to your
            Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are
            obligated not to disclose or use the information for any other purpose.</p>
          <p><br></p>
          <p>Security</p>
          <p>We value your trust in providing us your Personal Information, thus we are striving to
            use commercially acceptable means of protecting it. But remember that no method of transmission over the
            internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute
            security.</p>
          <p><br></p>
          <p>Children’s Privacy</p>
          <p>This Services do not address anyone under the age of 13. We do not knowingly collect
            personal identifiable information from children under 13. In the case we discover that a child under 13 has
            provided us with personal information, we immediately delete this from our servers. If you are a parent or
            guardian and you are aware that your child has provided us with personal information, please contact us so
            that we will be able to do necessary actions.</p>
          <p><br></p>
          <p>Changes to This Privacy Policy</p>
          <p>We may update our Privacy Policy from time to time. Thus, you are advised to review
            this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy
            on
            this page. These changes are effective immediately, after they are posted on this page.</p>
          <p><br></p>
          <p>Contact Us</p>
          <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to
            contact us.</p>
          <p>Contact Information: Email: info@masrafna.com.iq</p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  watch: {
  },
  mounted() {

  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped></style>